import { cva } from 'class-variance-authority';

export type FiltersSidebarVariant = 'primary' | 'dark';

const asideVariants = cva(
	'fixed left-0 top-0 z-[102] flex h-dvh w-full -translate-x-full flex-col duration-200 md:w-[30rem]',
	{
		variants: {
			variant: {
				primary: 'bg-white',
				dark: 'bg-primary'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);

const headerVariants = cva(
	'flex items-center justify-between gap-6 border-b px-5 py-3 md:py-5',
	{
		variants: {
			variant: {
				primary: 'border-white-dark-3',
				dark: 'border-white/10'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);

const headerTitleVariants = cva(
	'font-matter-sq text-2xl font-normal tracking-[-0.03rem]',
	{
		variants: {
			variant: {
				primary: 'text-primary',
				dark: 'text-white'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);

const closeIconVariants = cva('size-8', {
	variants: {
		variant: {
			primary: 'text-primary',
			dark: 'text-white'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const footerVariants = cva(
	'fixed bottom-0 left-0 z-[103] flex h-[4.25rem] w-full items-center justify-between border-t px-4 py-3 md:h-24 md:p-6',
	{
		variants: {
			variant: {
				primary: 'border-white-dark-3',
				dark: 'border-white/10'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);

const clearButtonVariants = cva('w-min border-none text-base font-medium', {
	variants: {
		variant: {
			primary: '',
			dark: 'text-white hover:text-white'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const separatorVariants = cva('mx-5', {
	variants: {
		variant: {
			primary: 'border-white-dark-3',
			dark: 'border-primary-light-3'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const loadingIconVariants = cva('size-6 animate-spin', {
	variants: {
		variant: {
			primary: 'text-white',
			dark: 'text-primary'
		}
	},
	defaultVariants: { variant: 'primary' }
});

export function getSidebarStyles(variant: FiltersSidebarVariant) {
	return {
		aside: asideVariants({ variant }),
		header: headerVariants({ variant }),
		headerTitle: headerTitleVariants({ variant }),
		closeIcon: closeIconVariants({ variant }),
		footer: footerVariants({ variant }),
		clearButton: clearButtonVariants({ variant }),
		separator: separatorVariants({ variant }),
		loadingIcon: loadingIconVariants({ variant }),
		applyButtonVariant: (variant === 'dark' ? 'white' : 'primary') as
			| 'white'
			| 'primary'
	};
}
